import { render, staticRenderFns } from "./av_details.vue?vue&type=template&id=6b67dc8d&scoped=true&"
import script from "./av_details.vue?vue&type=script&lang=js&"
export * from "./av_details.vue?vue&type=script&lang=js&"
import style0 from "./av_details.vue?vue&type=style&index=0&id=6b67dc8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67dc8d",
  null
  
)

export default component.exports